import { useState } from 'react';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

const TokenSettings = ({ actions = [] }) => {
  const [isActive, setIsActive] = useState(false);

  const toggleSettings = () => setIsActive(!isActive);

  return (
    <Box align="center">
      {isActive ? (
        actions.map(({ actionType, cb }) => (
          <Box key={`${actionType}-action`} padding="s">
            <Icon
              className={styles.icon}
              name={`icons/general/action/${actionType}`}
              size="l"
              color="accent_color_2"
              onClick={cb || toggleSettings}
            />
          </Box>
        ))
      ) : (
        <Box padding="xxs">
          <Box padding="s xs">
            <Icon
              className={styles.icon}
              name="icons/general/state/settings"
              size="m"
              color="accent_color_2"
              onClick={toggleSettings}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TokenSettings;
